import dayjs from 'dayjs';

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const TEXTDATEFORMAT = 'MMM D, YYYY';
export const FULLDATEFORMAT = 'ddd, MMM DD YYYY';
export const FULLTIMEFORMAT = 'MMM DD YYYY hh:mma';
export const MONTHFORMAT = 'YYYY-MM';
export const DATEFORMAT = 'YYYY-MM-DD';
export const TIMEFORMAT = 'hh:mma';

export const getCalendarDays = ({ year, month }) => {
  const firstDayOfMonth = new Date(year, month);
  const monthStartsAfterSunday = firstDayOfMonth.getDay() > 0;
  let firstDayOfCalendar = dayjs(firstDayOfMonth);
  if (monthStartsAfterSunday) {
    const daysPastSunday = firstDayOfMonth.getDay() - 0;
    firstDayOfCalendar = dayjs(firstDayOfMonth).subtract(daysPastSunday, 'day');
  }
  const daysOfMonth = () => (32 - new Date(year, month, 32).getDate());
  const lastDayOfMonth = new Date(year, month, daysOfMonth());
  const monthEndsBeforeSaturday = lastDayOfMonth.getDay() < 6;
  let lastDayOfCalendar = dayjs(lastDayOfMonth);
  if (monthEndsBeforeSaturday) {
    const daysBeforeSaturday = 6 - lastDayOfMonth.getDay();
    lastDayOfCalendar = dayjs(lastDayOfMonth).add(daysBeforeSaturday, 'day');
  }
  const days = [];
  let startDay = firstDayOfCalendar;
  do {
    days.push({
      date: startDay,
      month,
      year,
      inMonth: startDay.month() === month,
    });
    startDay = dayjs(startDay).add(1, 'day');
  } while (dayjs(startDay).isSameOrBefore(lastDayOfCalendar));
  return days;
};
